import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from '../../enums/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class RescueService {

   constructor(private httpService: HttpService) { }

   async getRescues(params:any){
            return new Promise((resolve, reject) => {
                try {

                    let config = this.httpService.setHeaderConfig(true);

                    let body = params
                    this.httpService.get(UrlConnectionEnum.GET_RESCUE_LIST, body, config).subscribe({
                        next: (data) => {
                            if(data.result){
                                resolve(data.result);
                            }else{
                              resolve(data)
                            }
                        },
                        error: (error) => {
                            reject(error);
                        }
                    });

                } catch (error) {
                    reject(error);
                }
            });
        }

           async getRescueStatus(){
            return new Promise((resolve, reject) => {
                try {

                    let config = this.httpService.setHeaderConfig(true);

                    let body = {}

                    this.httpService.get(UrlConnectionEnum.GET_RESCUE_STATUS, body, config).subscribe({
                        next: (data) => {
                            if(data.result){
                                resolve(data.result);
                            }else{
                              resolve(data)
                            }
                        },
                        error: (error) => {
                            reject(error);
                        }
                    });

                } catch (error) {
                    reject(error);
                }
            });
        }


        async updateRescue(rescue:any){
          return new Promise((resolve, reject) => {
              try {

                  let config = this.httpService.setHeaderConfig(true);
                  let body = rescue;

                  this.httpService.put(UrlConnectionEnum.UPDATE_RESCUE, body, config).subscribe({
                      next: (data) => {
                          if(data.result){
                              resolve(data.result);
                          }else{
                            resolve(data)
                          }
                      },
                      error: (error) => {
                          reject(error);
                      }
                  });

              } catch (error) {
                  reject(error);
              }
          });
      }
}
